import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({
  whatsapp_number: "+971508177523",
  whatsapp_message: "Hi! I'd like to know more about My Funding Bank.",
  calendly_url: "https://calendly.com/myfundingbank/advisor",
  loading: true,
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    whatsapp_number: "+971508177523",
    whatsapp_message: "Hi! I'd like to know more about My Funding Bank.",
    calendly_url: "https://calendly.com/myfundingbank/advisor",
    loading: true,
  });

  useEffect(() => {
    api.get("/settings")
      .then((r) => setSettings({ ...r.data, loading: false }))
      .catch(() => setSettings((s) => ({ ...s, loading: false })));
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);

export function buildWhatsappUrl(number, message) {
  const cleaned = (number || "").replace(/[^\d]/g, "");
  const msg = encodeURIComponent(message || "");
  return `https://wa.me/${cleaned}?text=${msg}`;
}
